<script lang="ts">
  import type { Snippet } from "svelte";
  import type { SettlementDetails } from "../types";
  import { formatGbp, formatPercent } from "../../../lib/formatting";

  let {
    settlementDetails,
    totalLabel = "You’ll receive",
    children,
    class: className,
  }: {
    settlementDetails: SettlementDetails;
    totalLabel?: string;
    children: Snippet;
    class?: string;
  } = $props();
</script>

<div class="border rounded-lg p-4 {className}">
  <div class="divide-y">
    <div class="pb-4">
      <div class="text-xs text-gray-500 font-medium mb-1">Compensation</div>
      <dl class="flex justify-between">
        <dt>Gross amount</dt>
        <dd>{formatGbp(settlementDetails.grossSettlementAmount)}</dd>
      </dl>
    </div>
    <div class="py-4">
      <div class="text-xs text-gray-500 font-medium mb-1">Deductions</div>
      <dl>
        <div class="flex justify-between mb-1">
          <dt>JLG fee ({formatPercent(settlementDetails.attorneyFeePercent, 2)})</dt>
          <dd>-{formatGbp(settlementDetails.jlgFeeAmount)}</dd>
        </div>
        <div class="flex justify-between">
          <dt>VAT (20% of JLG fee)</dt>
          <dd>-{formatGbp(settlementDetails.vatAmount)}</dd>
        </div>
      </dl>
    </div>
    <div class="py-4">
      <dl class="flex justify-between font-bold">
        <dt>{totalLabel}</dt>
        <dd>{formatGbp(settlementDetails.payoutAmount)}</dd>
      </dl>
    </div>
  </div>

  {@render children()}
</div>
